var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1187 9.54486C22.1187 9.95423 22.1187 11.2885 22.1187 13.1842H28.6362L27.9295 18.9941H22.1187C22.1187 27.9541 22.1187 39.9609 22.1187 39.9609H14.4057C14.4057 39.9609 14.4057 28.113 14.4057 18.9941H10.3867V13.1842H14.4057C14.4057 10.8801 14.4057 9.24173 14.4057 8.78556C14.4057 6.61212 14.242 5.58087 15.1655 3.89665C16.0895 2.21251 18.6957 -0.0135816 23.2034 0.0400121C27.7123 0.095559 29.6128 0.529309 29.6128 0.529309L28.6362 6.72126C28.6362 6.72126 25.757 5.96103 24.3438 6.23196C22.9325 6.50298 22.1187 7.37236 22.1187 9.54486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ed386983ae21b578ed753b564d7f4d03.svg";
export { ForwardRef as ReactComponent };